import { ReactNode } from 'react'
import * as React from 'react'

type Props = {
  transparent?: boolean
  children: ReactNode
}

const PageWrapper: React.FC<Props> = ({ transparent = true, children }) => {
  const getClassName = (): string => {
    return `page-wrapper ${transparent ? '' : 'bg-white'}`
  }

  return <div className={getClassName()}>{children}</div>
}

export default PageWrapper
